import {useEffect, useState} from 'react';
import {Redirect, useHistory} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {getActivityData} from '../../store/actionCreators';
import closeIcon from '../../../images/close-icon.svg';
import { deleteActivity } from '../../store/actionCreators';
import * as Styled from './ActivityItemStyles';

export interface ActivitiesItemStandardProps {
  item: ActivityItemData;
  when: string;
}

interface ActivityItemData {
  timestamp: string;
  text: string;
  type: string;
}

const getActivityName = (item:ActivityItemData) => {
  const txt:string = item.text.length > 206 ? item.text.substring(0, 206) + '...' : item.text;
  if (item.type === 'search') {
    return `Searched "${txt}"`
  }
  const types = item.type.split('_');
  if (types[0] === 'connect') {
    return `Connected ${types[1].charAt(0).toUpperCase()}${types[1].slice(1)} "${txt}"`
  }
  if (types[0] === 'log') {
    return `Logged in "${txt}"`
  }
  const typeName = types.map((t, i) => {
    if (i === 0) {
      return `${t.charAt(0).toUpperCase()}${t.slice(1)}ed`;
    }
    if (i === 1) {
      return `${t.charAt(0).toUpperCase()}${t.slice(1)}`;
    }
    return t;
  }).join(' ');
  return `${typeName} "${txt}"`
}

const ActivityItem = ({item, when}:ActivitiesItemStandardProps) => {
  const [isRedirect, setRedirect] = useState(false);
  const [time, setTime] = useState('');
	const dispatch = useDispatch();
  const history = useHistory();

  const handleDeleteActivity = () => {
    dispatch(deleteActivity({
      "timestamp": item.timestamp
    }));
    dispatch(getActivityData());
  }

  const handleActivityClick = () => {
    if(item.type === 'search'){
      history.push(`/searchresults?q=${item.text}`);
    }
    else{
      history.push('/account');
    }
  }

  useEffect(()=>{
    if(when === 'today'){
      let a = new Date(+item.timestamp * 1000).toLocaleTimeString('en-US', {"hour12": true, "hour": "2-digit", "minute": "2-digit"});
      
      setTime(a);
    }
    else{
      let a = new Date(+item.timestamp * 1000).toLocaleTimeString('en-US', {"hour12": true, "month": "2-digit", "day": "2-digit"});
      
      setTime(a.slice(0,5));
    }
  },[item.timestamp, when]);

  useEffect(() => {
    return () => {
      setRedirect(false);
    }
  },[])

  if(isRedirect){
    return <Redirect to='searchresults' />;
  }

  return (
    <Styled.Container className='ActivitiesItem' >
      <Styled.StyledParagraph className='Time'>
        {time}
      </Styled.StyledParagraph>
      <Styled.Container className='ForHover'>
        <Styled.Container className='ActivityElement' onClick={handleActivityClick} >
          {getActivityName(item)}
        </Styled.Container>
        <Styled.StyledImg className='HoverImg' src={closeIcon} alt='Close'
            onClick={()=>handleDeleteActivity()}
        />
      </Styled.Container>
    </Styled.Container>
  );
}

export default ActivityItem;